import { createFileRoute } from '@tanstack/react-router';

import { OrganizationSettingPage } from './-components/OrganizationSettingPage';

export const Route = createFileRoute('/_staff/organization/_list/settings/')({
  component: OrganizationSettingPage,
});
